import React from "react";

import { cn } from "./utils";

type RouteSummaryProps = React.HTMLAttributes<HTMLDivElement>;

export function RouteSummary({
  children,
  className,
  ...props
}: RouteSummaryProps) {
  return (
    <div className={cn("promo-route-summary", className)} {...props}>
      {children}
    </div>
  );
}
